import React, { useState } from 'react';
import { useRouter } from 'next/router';
import { LazyImage, Text } from '@ui/atoms';
import Button from '@ui/atoms/design-system/Button';
import { buttonSizes, buttonTypes } from '@ui/atoms/utils/enums';
import { cn } from '@ui/atoms/utils/utils';
import texts from '@components/Homepage/en.json';
import { triggerCustomGaEvent } from '@helpers/miscelleanous';
import { bondDirectoryGaEventsName } from '@helpers/ga-events-name-enum';
import routes from '@helpers/routes';

const BondDirectoryBanner = ({ className }) => {
    const [loading, setLoading] = useState(false);
    const router = useRouter();
    const navigateToBondDirectory = () => {
        setLoading(true);
        try {
            triggerCustomGaEvent(
                bondDirectoryGaEventsName.BOND_DIRECTORY_BANNER
            );
            router.push(routes.bonds.base);
        } catch (error) {
            console.error('Error redirecting to bond directory', error);
            setLoading(false);
        }
    };

    const {
        BondDirectoryBannerTitle,
        BondDirectoryBannerDescription,
        ExploreBondDirectory,
    } = texts;

    return (
        <section
            className={cn(
                "relative bg-[url('/images/homepage/bond-directory-bg.svg')] 2xl:bg-[length:200%] bg-no-repeat bg-[55%_50%] md:bg-[45%_60%] lg:bg-[35%_60%] xl:bg-[20%_60%] pb-10 pt-18 md:pb-12 md:pt-14 px-4 md:px-6 lg:pb-16 lg:pt-18 lg:px-16",
                className
            )}
        >
            <div className="flex flex-col gap-6 items-center md:items-start max-width-wrapper">
                <div className="flex flex-col gap-3 text-basicWhite">
                    <Text
                        content={BondDirectoryBannerTitle}
                        className="text-center md:text-left h4-semibold md:h3-semibold xl:h2-semibold"
                        isInnerHtml
                    />
                    <Text
                        content={BondDirectoryBannerDescription}
                        className="text-center md:text-left p4-regular"
                        isInnerHtml
                    />
                </div>
                <Button
                    onClick={navigateToBondDirectory}
                    buttonSize={buttonSizes.LARGE}
                    buttonText={ExploreBondDirectory}
                    buttonType={buttonTypes.TERTIARY}
                    className="hidden md:inline-flex !rounded-full"
                    isLoading={loading}
                />
                <Button
                    onClick={navigateToBondDirectory}
                    buttonSize={buttonSizes.REGULAR}
                    buttonText={ExploreBondDirectory}
                    buttonType={buttonTypes.TERTIARY}
                    className="!rounded-lg md:hidden"
                    isLoading={loading}
                />
            </div>
            <LazyImage
                src="/images/homepage/wave-pattern.svg"
                className="absolute top-[-20px] left-0 w-full overflow-hidden h-[40px]"
                imgClassName="w-full h-auto object-cover"
                style={{ maxWidth: 'none', width: 'auto' }}
            />
        </section>
    );
};

export default React.memo(BondDirectoryBanner);
